import { Children, Fragment, PropsWithChildren, ReactNode } from 'react';
import Divider from './Divider';

type SectionContainerProps = {} & PropsWithChildren;

export default function SectionContainer({ children }: SectionContainerProps) {
  const childrenArray = Children.toArray(children);

  return (
    <div className="w-full rounded-sm border border-neutral-40 p-4 flex flex-col gap-2">
      {childrenArray.map((child, index) => (
        <Fragment key={index}>
          {child}
          {childrenArray[index + 1] && <Divider />}
        </Fragment>
      ))}
    </div>
  );
}
